import styled from 'styled-components';
import Header from '../../organisms/Header';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const Content = styled.div`
  padding: 24px;
`;

const Card = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
`;

const CardTitle = styled.h2`
  font-size: 20px;
  color: #333;
  margin: 0 0 16px;
`;

const CardContent = styled.p`
  color: #666;
  line-height: 1.6;
`;

const DashboardPage = () => {
  return (
    <Container>
      <Header />
      <Content>
        <Card>
          <CardTitle>대시보드에 오신 것을 환영합니다!</CardTitle>
          <CardContent>
            로그인에 성공하셨습니다. 이곳에서 다양한 기능을 사용할 수 있습니다.
          </CardContent>
        </Card>

        <Card>
          <CardTitle>시작하기</CardTitle>
          <CardContent>
            Firebase Firestore와 연동되어 있습니다.
            useFirestore Hook을 사용하여 데이터를 관리할 수 있습니다.
          </CardContent>
        </Card>
      </Content>
    </Container>
  );
};

export default DashboardPage;
